import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './data-grid.css';
import './pop-up.css';
import './dropdown-button.css';
import './text-editor.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux"
import { store } from "./state/store"

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
